export default "__VITE_ASSET__DMRtwMw$__"